<template>
	<div class="search-bar">
		<form class="search-bar-inner" :class="{'has-predictions': predictions && showPredictions}">
			<input @keyup="navigatePredictions" @focus="showPredictions = true" @blur="inputBlur()" type="text" v-model="searchAddress" placeholder="Enter your street address to check coverage in your area">
			<loader v-if="loading"></loader>
			<span class="icon"><svg><use xlink:href="#search"></use></svg></span>
			<ul class="search-predictions" v-if="predictions && showPredictions">
				<li v-for="(prediction, index) in predictions" :class="{'is-selected': predictionIndex === index}" @click="selectPrediction(prediction)">
					{{ prediction.description }}
				</li>
			</ul><!-- end.search-predictions -->
		</form><!-- end.search-bar-inner -->
	</div><!-- end.search-bar -->
</template>
<script>
	import Loader from './Loader'
	import {gmapApi} from 'vue2-google-maps'
	import GoogleService from '../services/google'

	export default {
		components: {
			Loader,
		},
		computed: {
			google: gmapApi,
			place() {
				return this.$store.getters['coverage/place']
			}
		},
		watch: {
			place: function(newVal) {
				if(newVal) {
					this.setSearchBarValue(newVal.formatted_address);
				}
			},
			searchAddress: function(newVal, oldVal) {

				// clear current list of predictions
				this.predictions = false;

				// hide predictions list
				this.showPredictions = false;

				if(!this.searchAddress || this.searchAddress.length < 3 || newVal === oldVal || this.disablePredictions) {
					return false;
				}

				// cancel the timer to get predictions
				clearTimeout(this.timer);

				// hide loading indicator
				this.loading = false;

				if(this.searchAddress.length >= 3) {
					// set timeout to get predictions
					this.timer = setTimeout(() => {
						this.getPredictions();
					}, 1000);
				}
			}
		},
		data() {
			return {
				searchAddress: '',
				timer: null,
				predictions: false,
				loading: false,
				showPredictions: false,
				predictionIndex: -1,
				disablePredictions: false,
			}
		},
		methods: {
			inputBlur() {
				let that = this;
				setTimeout(() => {
					that.showPredictions = false;
					that.predictionIndex = -1;
				}, 200);
			},
			getPredictions() {
				// show loading indicator
				this.loading = true;
				let google = this.google;

				// get address predictions using Google Service
				GoogleService.getPlacePredictions(google, this.searchAddress)
					.then(response => {

						// set data to Vue instance state
						this.predictions = response;

						// show predictions list
						this.showPredictions = true;

						// hide loading indicator
						this.loading = false;
					}, error => {
						console.log('Error: ', error);
						// hide the loading indicator
						this.loading = false;
					})
			},
			selectPrediction(prediction) {
				let that = this;
				let google = that.google;

				// disable search predictions
				that.disablePredictions = true;

				// set the search address
				that.searchAddress = prediction.description;

				// geocode the selected prediction
				GoogleService.geocodeLatLng(google, {
					placeId: prediction.place_id,
				}).then(response => {
					// show the map
					that.$store.commit('coverage/updatePlace', response);

					// re-enable the predictions
					that.disablePredictions = false;
				});
			},
			navigatePredictions(key) {
				if(this.showPredictions && this.predictions) {
					switch(key) {

						// up key
						case 38:
							if(this.predictionIndex < this.predictions.length-1) {
								this.predictionIndex++;
							}
							break;

						// down key
						case 40:
							if(this.predictionIndex > 0) {
								this.predictionIndex--;
							}
							break;

						// enter key
						case 13:
							this.selectPrediction(this.predictions[this.predictionIndex]);
							break;

						default:
							this.predictionIndex = -1;
					}
				}
			},
			setSearchBarValue(value) {
				// disable search predictions
				this.disablePredictions = true;

				this.searchAddress = value;

				setTimeout(() => {
					// re-enable the predictions
					this.disablePredictions = false;
				}, 100);
			},
		},
		mounted() {
			if(this.place) {
				this.setSearchBarValue(this.place.formatted_address);
			}
		}
	}
</script>
